/* sp-spam-guard v2: layered, invisible client-side contact-form checks (Spellpaws).
   Real users always get a clear message; nothing is silently dropped. */
(function () {
  'use strict';
  if (window.__spSpamGuard) { window.__spSpamGuard.scan(); return; }
  var MIN_MS = 8000, MIN_KEYS = 1, MIN_FIELDS = 2, TOK_MAX = 2 * 3600 * 1000;
  var RL_MAX = 3, RL_WINDOW = 10 * 60 * 1000, RL_KEY = 'spSpamGuardSubmits', DUP_KEY = 'spSpamGuardEmails', DUP_WINDOW = 24 * 3600 * 1000;
  var KW = /\b(seo services?|search engine optimi[sz]ation|backlinks?|link ?building|crypto(currency)?|bitcoin|forex|casino|gambling|betting|payday|loans?|viagra|cialis|guest post|web traffic|rank(ing)? (your|on) google|first page of google)\b/i;
  var URL_RE = /(https?:\/\/|www\.)[^\s]+|\b[a-z0-9-]+\.(com|net|org|ru|cn|xyz|top|info|biz|io|co)\b(\/\S*)?/gi;
  var FOREIGN = /[\u0400-\u04FF\u3040-\u30FF\u3400-\u9FFF\uAC00-\uD7AF]/g;
  var GREET = /^(hello|hi|hey|hiya|yo|test(ing)?|hola|greetings|good (morning|afternoon|evening)|hello there|hi there|hey there|ok|okay|thanks|thank you|asdf\w*|qwerty|\.+)$/i;
  var ORDER_RE = /^#?\d{4,}$/;

  function now() { return Date.now(); }
  function countUrls(s) { return (String(s || '').match(URL_RE) || []).length; }
  function ls(k, d) { try { var v = JSON.parse(localStorage.getItem(k) || 'null'); return v == null ? d : v; } catch (e) { return d; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function rlRead() { var a = ls(RL_KEY, []), c = now() - RL_WINDOW; return Array.isArray(a) ? a.filter(function (t) { return t > c; }) : []; }
  function field(form, n) { return form.querySelector('[name="' + n + '"]'); }
  function val(form, n) { var el = field(form, n); return el ? String(el.value || '').trim() : ''; }
  function hash(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return (h >>> 0).toString(36); }
  function rnd() { var r = new Uint32Array(2); if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(r); else { r[0] = Math.random() * 4e9; r[1] = Math.random() * 4e9; } return r[0].toString(36) + r[1].toString(36); }
  function emailKey(e) { return hash(String(e || '').toLowerCase()); }

  function badName(n) {
    if (!n) return false;
    if (countUrls(n) > 0 || /[@<>]|https?:/i.test(n)) return true;
    var latin = n.replace(/[^A-Za-z\u00C0-\u024F]/g, '');
    if (latin.length >= 2 && !/[aeiouyAEIOUY\u00C0-\u00C6\u00C8-\u00CF\u00D2-\u00D6\u00D8-\u00DD\u00E0-\u00E6\u00E8-\u00EF\u00F2-\u00F6\u00F8-\u00FD\u0100-\u0105\u0112-\u011B\u012A-\u0131\u014C-\u0151\u0168-\u0173]/.test(latin)) return true;
    var words = n.split(/\s+/);
    for (var i = 0; i < words.length; i++) {
      var w = words[i].replace(/[^A-Za-z]/g, '');
      if (/[bcdfghjklmnpqrstvwxz]{5,}/i.test(w)) return true;                      // consonant mash
      if (w.length >= 10 && w === w.toUpperCase()) return true;                     // long all-caps blob
      if (w.length >= 6 && (w.slice(1).match(/[A-Z][a-z]|[a-z][A-Z]/g) || []).length >= 3) return true; // rAnDoM case
    }
    return false;
  }

  /* Returns {code, field, msg}. User-fixable issues name the field; bot signals use a generic message. */
  function evaluate(form, st) {
    var g = form.querySelector('[data-sp-spam-guard]');
    var hp = g.querySelector('[data-sp-hp]');
    var email = g.getAttribute('data-sp-email') || 'info@spellpaws.com';
    var generic = 'Hmm, something looked off. Please take a moment and try again, or email us at ' + email + '.';
    if (hp && hp.value) return { code: 'hp', msg: generic };
    var body = val(form, 'contact[body]'), name = val(form, 'contact[name]');
    var topic = val(form, 'contact[Topic]'), order = val(form, 'contact[Order number]');
    // user-fixable checks first, so real people get a useful message
    if (badName(name)) return { code: 'name', field: 'contact[name]', msg: 'Please enter your real name (letters only, no links).' };
    if (/^my order$/i.test(topic) && !ORDER_RE.test(order.replace(/\s+/g, ''))) return { code: 'order', field: 'contact[Order number]', msg: order ? 'That order number doesn\u2019t look right. It\u2019s the number in your confirmation email, like #1234.' : 'Please add your order number (from your confirmation email, like #1234) so we can find it.' };
    var words = body.split(/\s+/).filter(Boolean);
    if (GREET.test(body.replace(/[!?.,\s]+$/, '').trim()) || body.length < 20 || words.length < 4) return { code: 'short', field: 'contact[body]', msg: 'Tell our cat a little more: please write at least a full sentence (20+ characters) so we can help.' };
    var urls = countUrls(body);
    if (urls > 2) return { code: 'links', field: 'contact[body]', msg: 'Please include at most two links in your message.' };
    // bot signals
    if (now() - st.t0 < MIN_MS) return { code: 'fast', msg: 'That was quick! Please check your message, then send it again in a few seconds.' };
    if (st.keys < MIN_KEYS) return { code: 'nointeract', msg: generic };
    if (Object.keys(st.fields).length < MIN_FIELDS) return { code: 'nofocus', msg: generic };
    if (!tokenOk(form, st)) return { code: 'token', msg: 'This page has been open a while. Please refresh it and send your message again.' };
    if (KW.test(body) || KW.test(name)) return { code: 'keyword', msg: generic };
    var letters = (body.match(/\p{L}/gu) || []).length, f = (body.match(FOREIGN) || []).length;
    if (urls > 0 && letters > 0 && f / letters > 0.5) return { code: 'foreign+link', msg: generic };
    var dup = ls(DUP_KEY, {}), ek = emailKey(val(form, 'contact[email]'));
    if (dup && dup[ek] && now() - dup[ek] < DUP_WINDOW) return { code: 'dup', msg: 'You already sent us a message from this email in the last 24 hours. We\u2019ll reply soon! To add something, email ' + email + '.' };
    if (rlRead().length >= RL_MAX) return { code: 'rate', msg: 'Too many messages in a short time. Please wait a few minutes, or email ' + email + '.' };
    return null;
  }

  function makeToken(st) { st.ts = now(); return 'v2-' + st.ts.toString(36) + '-' + st.nonce + '-' + hash(st.ts + ':' + st.nonce + ':' + location.pathname); }
  function tokenOk(form, st) {
    var t = form.querySelector('[data-sp-token]'); if (!t) return false;
    var p = String(t.value).split('-'); if (p.length !== 4 || p[0] !== 'v2' || p[2] !== st.nonce) return false;
    var ts = parseInt(p[1], 36); if (!(ts > 0) || now() - ts > TOK_MAX || ts > now() + 60000) return false;
    return p[3] === hash(ts + ':' + st.nonce + ':' + location.pathname);
  }

  function clearInline(form) {
    form.querySelectorAll('[data-sp-ferr]').forEach(function (p) { var i = p.__spFor; if (i) { i.removeAttribute('aria-invalid'); var d = (i.getAttribute('aria-describedby') || '').split(' ').filter(function (x) { return x && x !== p.id; }).join(' '); d ? i.setAttribute('aria-describedby', d) : i.removeAttribute('aria-describedby'); } p.remove(); });
  }
  function showInline(form, name, text) {
    var i = field(form, name); if (!i) return false;
    var p = document.createElement('p'); p.className = 'sp-sg__ferr'; p.setAttribute('data-sp-ferr', ''); p.id = (i.id || 'sp-f') + '-sperr'; p.textContent = text; p.__spFor = i;
    p.style.cssText = 'margin:6px 0 0;font-size:13px;line-height:1.35;color:#b3264f';
    i.insertAdjacentElement('afterend', p);
    i.setAttribute('aria-invalid', 'true'); i.setAttribute('aria-describedby', ((i.getAttribute('aria-describedby') || '') + ' ' + p.id).trim());
    i.focus(); return true;
  }

  function attach(g) {
    var form = g.closest('form');
    if (!form || form.__spSG) return;
    var st = form.__spSG = { t0: now(), keys: 0, fields: {}, nonce: rnd() };
    var tok = g.querySelector('[data-sp-token]');
    if (tok) tok.value = makeToken(st);
    function real(e) { return e.isTrusted !== false && !(e.target && e.target.hasAttribute && e.target.hasAttribute('data-sp-hp')); }
    // any real interaction with the message counts: typing, paste, drop, autofill, dictation
    ['keydown', 'paste', 'drop', 'input'].forEach(function (t) { form.addEventListener(t, function (e) { if (real(e) && e.target && e.target.name === 'contact[body]') st.keys++; }); });
    ['focusin', 'focusout'].forEach(function (t) { form.addEventListener(t, function (e) { if (real(e) && e.target && e.target.name && e.target.name.indexOf('contact[') === 0) st.fields[e.target.name] = 1; }); });
    form.addEventListener('input', function (e) { if (e.target && e.target.hasAttribute && e.target.getAttribute('aria-invalid') === 'true') clearInline(form); });
    // order number hint: mark it required when topic is "My order"
    var topic = field(form, 'contact[Topic]'), order = field(form, 'contact[Order number]');
    function syncOrder() { if (!order || !topic) return; var req = /^my order$/i.test(topic.value); order.setAttribute('aria-required', String(req)); order.placeholder = req ? 'e.g. #1234 (required)' : ''; }
    if (topic) { topic.addEventListener('change', syncOrder); syncOrder(); }
    // refresh the token hourly so long-open tabs stay valid
    setInterval(function () { if (tok) tok.value = makeToken(st); }, 3600 * 1000);
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || !form.__spSG) return;
    var g = form.querySelector('[data-sp-spam-guard]');
    var msg = g.querySelector('[data-sp-msg]');
    clearInline(form);
    var r = evaluate(form, form.__spSG);
    form.__spSG.lastReason = r ? r.code : null;
    if (r) {
      e.preventDefault(); e.stopImmediatePropagation();
      msg.textContent = r.msg; msg.hidden = false;
      if (!(r.field && showInline(form, r.field, r.msg))) msg.focus && msg.focus();
      return;
    }
    msg.hidden = true; msg.textContent = '';
    var a = rlRead(); a.push(now()); lsSet(RL_KEY, a);
    var d = ls(DUP_KEY, {}), c = now() - DUP_WINDOW; Object.keys(d).forEach(function (k) { if (d[k] < c) delete d[k]; });
    d[emailKey(val(form, 'contact[email]'))] = now(); lsSet(DUP_KEY, d);
  }

  function scan(root) { (root || document).querySelectorAll('[data-sp-spam-guard]').forEach(attach); }
  document.addEventListener('submit', onSubmit, true);
  window.__spSpamGuard = { scan: scan, evaluate: evaluate, badName: badName, _cfg: { MIN_MS: MIN_MS, MIN_KEYS: MIN_KEYS } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
